module.exports = __webpack_public_path__ + "img/installation.c4a01108.svg";